import { InjectionToken } from '@angular/core';
import { PermissionConfig } from './permission.config';

export const PERMISSION_CONFIG_TOKEN =
    new InjectionToken<PermissionConfig>('PERMISSION_CONFIG_TOKEN');
